<template>
  <div v-if="isShow" class="go" @click="goTop">
    <!-- <img src="../../assets/img/gotop-icon.png" alt=""> -->
    顶部
  </div>
</template>

<script>
export default {
  data(){
    return{
      isShow: false
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      this.isShow = scrollTop > 300
    },
    goTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(top)
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
};
</script>

<style lang="scss">
.go {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background: #228A83;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img{
    width: 25px;
    height: 25px;
  }
}
</style>